/**
 */
export default {
  printable: ''
}
